import { cineamoApiClient as apiClient } from '../../apiClient';
import { UrlQueryParameter, buildUrlQuery } from '../../helpers/url-query-helper';
import { CartItemDto } from '../../models/cart-item/CartItemDto.types';
import { CartItemInputDto } from '../../models/cart-item/CartItemInputDto';
import { ApiErrorResponse } from '../../types/ApiErrorResponse.types';
import { CartItemListResponse } from '../../types/ApiListResponse.types';
import { ApiResponse } from '../../types/ApiResponse.types';

export async function getCartItemById(id: number | string, cartUuid: string): Promise<ApiResponse<CartItemDto> | null> {
    return apiClient
        .get<ApiResponse<CartItemDto>>(`/carts/${cartUuid}/cart-items/${id}`, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.data)
        .catch(() => null);
}

export async function getCartItems(
    cartUuid: string,
    params?: UrlQueryParameter
): Promise<ApiResponse<CartItemListResponse> | null> {
    return apiClient
        .get(`/carts/${cartUuid}/cart-items${buildUrlQuery(params)}`, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.data as CartItemListResponse)
        .catch(() => null);
}

export async function addCartItem(
    cartItem: CartItemInputDto,
    cartUuid: string
): Promise<ApiResponse<CartItemDto> | ApiErrorResponse<CartItemInputDto>> {
    return apiClient
        .post(`/carts/${cartUuid}/cart-items`, cartItem, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.data)
        .catch((error) => error);
}

export async function setCartItemsBulk(
    cartItems: CartItemInputDto[],
    cartUuid: string
): Promise<ApiResponse<CartItemListResponse> | ApiErrorResponse<CartItemInputDto>> {
    return apiClient
        .put(`/carts/${cartUuid}/cart-items`, cartItems, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.data)
        .catch((error) => error);
}

export async function updateCartItem(cartItem: CartItemInputDto, cartUuid: string): Promise<ApiResponse<CartItemDto>> {
    return apiClient
        .patch(`/carts/${cartUuid}/cart-items/${cartItem.id}`, cartItem, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.data)
        .catch((error) => error);
}

// <------------------------ Delete CartItem ------------------------>

export async function deleteCartItemById(cartItemId: number, cartUuid: string): Promise<boolean> {
    return apiClient
        .delete(`/carts/${cartUuid}/cart-items/${cartItemId}`, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.status === 204)
        .catch(() => false);
}
